const name = 'PopOut';
const properties = {
    groups: ['exit', 'animation'],
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
        power: {
            type: 'string',
            enum: ['soft', 'medium', 'hard'],
            default: 'hard',
        },
    },
};
const scaleMap = {
    soft: 0.8,
    medium: 2.4,
    hard: 4,
};
/**
 * Pop Out to
 */
function animate(kit, elements, duration, delay, { power = properties.schema.power.default, ...params } = {}) {
    const sequence = kit.sequence(params);
    const scale = scaleMap[power];
    sequence.add([
        kit.animate('BaseFade', elements, duration * 0.75, delay + duration * 0.25, { from: { opacity: 1 }, to: { autoAlpha: 0 }, ease: 'Sine.easeOut' }),
        kit.animate('BaseScale', elements, duration, delay, {
            to: { scale },
            ease: 'Sine.easeOut',
        }),
    ]);
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=popOut.js.map